import apiClient from '@/repositories/apiClient';
import { api } from './api';

// Holiday-media has a two-step upload flow analogous to the element gallery:
// 1. Multipart upload to /api/holiday-media/upload returns a temp filename.
// 2. POST /api/holiday-media with metadata + temp filename creates the row
//    and triggers async conversion. The frontend polls the show endpoint
//    until `status` flips to "ready" or "failed".
//
// We expose the upload as a plain async function (not as an RTK mutation)
// because the multipart body cannot be serialised through axiosBaseQuery.
export const uploadHolidayMediaFile = async (file, onProgress) => {
  const form = new FormData();
  form.append('file', file);
  const response = await apiClient({
    url: '/holiday-media/upload',
    method: 'POST',
    data: form,
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: (e) => {
      if (onProgress && e.total) {
        onProgress(Math.round((e.loaded * 100) / e.total));
      }
    },
  });
  return response.data;
};

export const holidayMediaApi = api.injectEndpoints({
  endpoints: (build) => ({
    // Phase 2 of the upload: register the row + trigger conversion.
    createHolidayMedia: build.mutation({
      query: (body) => ({
        url: 'holiday-media',
        method: 'POST',
        body: JSON.stringify(body),
      }),
    }),
    // Used by the frontend to poll until status transitions to ready/failed.
    getHolidayMedia: build.query({
      query: (id) => ({ url: `holiday-media/${id}`, method: 'GET' }),
      transformResponse: (r) => r.data,
    }),
    deleteHolidayMedia: build.mutation({
      query: (id) => ({ url: `holiday-media/${id}`, method: 'DELETE' }),
    }),
  }),
});

export const {
  useCreateHolidayMediaMutation,
  useGetHolidayMediaQuery,
  useLazyGetHolidayMediaQuery,
  useDeleteHolidayMediaMutation,
} = holidayMediaApi;
